/*
  * Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
  * SPDX-License-Identifier: MIT
  *
  * Licensed under the MIT License. See the LICENSE accompanying this file
  * for the specific language governing permissions and limitations under
  * the License.
  */

/*
 * If the token swap failed in Authorize lambda then we logout before continuing PKCE
 */

import { Auth } from 'aws-amplify';

import { eraseCookie } from './cookieHelper';

const saveParamsToLocalStorage = () => {
  // Store redirect_uri/authorization_code in local storage to be used to later
  let queryStringParams = new URLSearchParams(window.location.search);
  let redirect_uri = queryStringParams.get("redirect_uri");
  let authorization_code = queryStringParams.get("authorization_code");
  let clientState = queryStringParams.get("state");

  if (redirect_uri) {
    localStorage.setItem(`client-redirect-uri`, redirect_uri);
  }
  if (authorization_code) {
    localStorage.setItem(`authorization_code`, authorization_code);
  }
  if (clientState) {
    localStorage.setItem(`client-state`, clientState);
  }
};

const checkForceAuth = async () => {
	const forceAuth = new URLSearchParams(window.location.search).get("forceAuth") || false;

	if (forceAuth) {
    saveParamsToLocalStorage();
		eraseCookie("id_token");
		eraseCookie("access_token");
		eraseCookie("refresh_token");

		// localStorage.removeItem("client-id");

    // handle global signout
    try {
      await Auth.signOut({
        global: true,
      });
    } catch (error: any) {
      // when other client has been logged out / access token has ben revoked, do regular signOut
      if (error.code === 'NotAuthorizedException') {
        await Auth.signOut();
      }
    }
	}
};

export default checkForceAuth;